module.exports = __webpack_public_path__ + "assets/img/fd8e-in.svg";